module.exports = __webpack_public_path__ + "static/media/white-add-edit-data-icon.311ae1f6.svg";